var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
            ]),
            _vm.navName == 1
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/myCustomers" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("我的客户")])]
                )
              : _vm._e(),
            _vm.navName == 2
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/assign_custom" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("分配客户")])]
                )
              : _vm._e(),
            _vm.navName == 3
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/openCustomers" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("公开客户")])]
                )
              : _vm._e(),
            _c(
              "el-breadcrumb-item",
              {
                attrs: {
                  to: {
                    path: "/customerInformation",
                    query: { id: this.$route.query.id, nav: 1 },
                  },
                },
              },
              [_c("div", { staticClass: "div3" }, [_vm._v("客户资料")])]
            ),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/myCustomers" } } },
              [_c("div", { staticClass: "div2" }, [_vm._v("查看附件")])]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "uplod" },
      [
        _c(
          "el-upload",
          {
            staticClass: "video",
            attrs: {
              action: "#",
              multiple: "",
              limit: 3,
              "on-exceed": _vm.handleExceed,
              "before-upload": _vm.beforeUploadVideo,
              "http-request": _vm.videoUpload,
              "show-file-list": false,
            },
          },
          [
            _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
              _vm._v("选择视频"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "uplod" },
      [
        _c(
          "el-upload",
          {
            ref: "upload",
            staticClass: "video",
            attrs: {
              action: "#",
              multiple: "",
              "before-upload": _vm.beforeUploadImg,
              "http-request": _vm.imgUpload,
              "show-file-list": false,
            },
          },
          [
            _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
              _vm._v("选择图片"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { staticClass: "video" },
        [
          _vm._l(_vm.customerVideo, function (itemsVideo, index) {
            return _vm.customerVideo
              ? _c("div", { staticClass: "li" }, [
                  itemsVideo
                    ? _c(
                        "video",
                        {
                          staticClass: "video-avatar",
                          attrs: {
                            src: _vm.ImgHttps + itemsVideo.video,
                            controls: "controls",
                          },
                        },
                        [_vm._v(" 您的浏览器不支持视频播放 ")]
                      )
                    : _vm._e(),
                  itemsVideo
                    ? _c("p", [_vm._v(_vm._s(itemsVideo.creattime))])
                    : _vm._e(),
                  itemsVideo
                    ? _c(
                        "p",
                        {
                          staticClass: "close",
                          on: {
                            click: function ($event) {
                              return _vm.delectList(index)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-error" })]
                      )
                    : _vm._e(),
                ])
              : _vm._e()
          }),
          _vm._l(_vm.customerImage, function (itemsImg, index) {
            return _vm.customerImage
              ? _c("div", { staticClass: "liimg" }, [
                  itemsImg
                    ? _c("img", {
                        directives: [
                          { name: "image-preview", rawName: "v-image-preview" },
                        ],
                        staticClass: "img-avatar",
                        attrs: { src: _vm.ImgHttps + itemsImg.img },
                      })
                    : _vm._e(),
                  itemsImg
                    ? _c("p", [_vm._v(_vm._s(itemsImg.creattime))])
                    : _vm._e(),
                  itemsImg
                    ? _c(
                        "p",
                        {
                          staticClass: "close",
                          on: {
                            click: function ($event) {
                              return _vm.delectImgList(index)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-error" })]
                      )
                    : _vm._e(),
                ])
              : _vm._e()
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }